import './post.css';
// import { fabric } from 'fabric';
import Like from '../like/Like'; // adjust the path as needed
import MyFriendsToSharePost from '../../components/myFriendsToSharePost/MyFriendsToSharePost';
import Button from 'react-bootstrap/Button';
import { MoreVert } from '@material-ui/icons';
import { IconButton, MenuItem, Menu } from '@material-ui/core';
import {
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from 'react';
//import { Button, Comment, Form, Header } from 'semantic-ui-react';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import axiosConn from '../../axiosConn';
import { CircularProgress } from '@material-ui/core';
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DynamicHtml from '../dynamicHtml/DynamicHtml';
import Comment from '../comment/Comment';
import CreateComment from '../createComment/CreateComment';
// import { format } from 'timeago.js';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import ReactPlayer from 'react-player/lazy';
import { useMediaQuery } from 'react-responsive';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CurrencyExchangeOutlinedIcon from '@mui/icons-material/CurrencyExchangeOutlined';
import { Tooltip } from '@mui/material';
import useClickOutside from '../../clickOutside';
// import { ClipLoader } from 'react-spinners';
import Modal from '../modal/Modal';
import checkHtmlDialogElement from '../../utils/checkHtmlDialogElement';
import playSound from '../../utils/playSound';
import { SocketContext } from '../../context/socket';
import { ViewPortContext } from '../../context/ViewPortContext';
import Form from 'react-bootstrap/Form';
import isVideoFile from '../../utils/isVideoFile';
import isImageFile from '../../utils/isImageFile';

import preciseFormat from '../../utils/preciseFormat';
import ModalImage from 'react-modal-image';
import { useTheme } from '../../context/ThemeContext';
import useStyles from '../../utils/useStyles';
import { Room } from '@material-ui/icons';
import ReactionBar from '../reactionBar/ReactionBar';

const winningSound =
  'https://res.cloudinary.com/joegalaxy/video/upload/v1713899521/y2mate_HrgsElu_gxito3.mp3';

export default function Post({
  galaxy = null,
  initialPost,
  onDelete,
  // handlePostClick
}) {
  // console.log(initialPost);
  const [post, setPost] = useState(initialPost);
  const { player: loggedInPlayer } = useContext(AuthContext);
  const checkbox = useRef();

  const [like, setLike] = useState(post?.likes?.length || 0);
  const [share, setShare] = useState(
    (post?.rePosts?.length || 0) + (post?.reShares?.length || 0),
  );
  const [jgkd, setJgkd] = useState(post?.jgkd?.length || 0);
  // const [isJgkd, setIsJgkd] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  // const [isShared, setIsShared] = useState(false);

  const [views, setViews] = useState(post?.views);

  const [player, setPlayer] = useState({});
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const { player: currentPlayer } = useContext(AuthContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isShown, setIsShown] = useState(false);
  //const [isCloud, setIsCloud] = useState(false);
  const [commentCount, setCommentCount] = useState(1);
  const [comments, setComments] = useState(post?.comments || []);
  const commentCountRef = useRef(1);

  const [isQAutoUrl, SetIsQAutoUrl] = useState(post?.img?.includes('q_auto'));
  const [isProgressiveUrl, SetIsProgressiveUrl] = useState(
    post?.img?.includes('fl_progressive:steep'),
  );
  const [qAutoUrl, SetQAutoUrl] = useState('');
  const [likePlayer, setLikePlayer] = useState({});
  const [likeProfileImgs, setlikeProfileImgs] = useState([]);
  const [messageTextIsVideo, setMessageTextIsVideo] = useState(false);
  const [jgkOnPost, setJGKOnPost] = useState(false);
  const [jgkTokens, setJgkTokens] = useState(post?.jgkTokens || 0);
  const [isLoading, setIsLoading] = useState(false);
  const [sendJGKToPostAmount, setSendJGKToPostAmount] = useState(0);
  const [myFriends, SetMyFriends] = useState([]);
  const [myFriendsToSharePost, SetMyFriendsToSharePost] = useState([]);

  const { socket: socket2 } = useContext(SocketContext);
  const [onlinePlayers, setOnlinePlayers] = useState([]);
  const [currentChat, setCurrentChat] = useState(null);
  const [loading, setLoading] = useState(false);
  // const [repostTrigger, setRepostTrigger] = useState(false); // State variable to track reposts

  // let subtitle;
  const [modal, setModal] = useState(false);
  const [isShare, setIsShare] = useState(false);
  const [isRepost, setIsRepost] = useState(false);
  const [dialogIsSupported, setDialogIsSupported] = useState(false);
  const imgRef = useRef(null);
  const [textPosition, setTextPosition] = useState({ top: '0px', left: '0px' });
  const [isSoundPlaying, setIsSoundPlaying] = useState(false);
  const [showText, setShowText] = useState(false);
  const [liveViewers, setLiveViewers] = useState(0);
  const [commentTypingHint, setCommentTypingHint] = useState('');
  const typingTimeoutRef = useRef(null);

  const [isVideo, setIsVideo] = useState(false);
  const [normalizedUrl, setNormalizedUrl] = useState(post?.img || '');
  const [posterUrl, setPosterUrl] = useState('');
  const [mediaLoading, setMediaLoading] = useState(true);
  const [mediaError, setMediaError] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const [isImageZoomOpen, setIsImageZoomOpen] = useState(false);
  const videoRef = useRef(null);
  const mediaContainerRef = useRef(null);
  const thumbsRef = useRef(null);
  const playRequestedRef = useRef(false);
  const [mediaDims, setMediaDims] = useState({ w: 0, h: 0 });
  const isPortrait = mediaDims.h > mediaDims.w && mediaDims.w > 0;
  const mediaList = useMemo(() => {
    const buildEntry = (item) => {
      if (!item) return null;
      if (typeof item === 'string') {
        return { url: item, type: isVideoFile(item) ? 'video' : 'image' };
      }
      const url =
        item.url ||
        item.secure_url ||
        item.secureUrl ||
        item.preview ||
        item.src ||
        null;
      if (!url) return null;
      const type = item.type || (isVideoFile(url) ? 'video' : 'image');
      return { url, type };
    };

    if (Array.isArray(post?.media) && post.media.length) {
      return post.media.map(buildEntry).filter(Boolean);
    }
    if (Array.isArray(post?.images) && post.images.length) {
      return post.images.map(buildEntry).filter(Boolean);
    }
    if (post?.img)
      return [
        { url: post.img, type: isVideoFile(post.img) ? 'video' : 'image' },
      ];
    return [];
  }, [post]);
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      // console.log('[post media] count', mediaList.length, mediaList);
    }
  }, [mediaList]);
  const [mediaIndex, setMediaIndex] = useState(0);
  const [thumbNav, setThumbNav] = useState({ canPrev: false, canNext: false });
  const currentMedia = mediaList[mediaIndex] || null;
  const activeUrl = currentMedia?.url || post?.img || '';

  useEffect(() => {
    setMediaIndex(0);
  }, [mediaList]);

  useEffect(() => {
    setJgkd(post?.jgkd?.length || 0);
    setJgkTokens(post?.jgkTokens || 0);
  }, [post?.jgkd, post?.jgkTokens]);

  //const MyOptions = ['Delete Post', 'Edit Post'];
  const MyOptions = ['Delete Post'];
  const mobileView = useMediaQuery({
    query: '(max-width: 805px)',
  });
  const { width } = useContext(ViewPortContext);
  const numOfImages = width <= 280 ? 4 : 6;
  const menu = useRef(null);
  const [isShownMenuItem, setIsShownMenuItem] = useState(false);

  // --- Helper: unify Cloudinary transform normalization ---
  const buildNormalizedUrl = useCallback((url) => {
    if (!url || typeof url !== 'string') return url;
    if (!url.includes('/upload/')) return url;

    const UP = '/upload/';
    const [left, right] = url.split(UP);
    const tailParts = right.split('/');

    // Collect all transform path segments until version marker v123...
    const txSegs = [];
    while (tailParts.length && !/^v\d+/.test(tailParts[0])) {
      txSegs.push(tailParts.shift());
    }
    // Merge (some URLs embed transforms as separate path components)
    let tx = txSegs
      .join(',')
      .split(',')
      .map((t) => t.trim())
      .filter(Boolean);

    const video = isVideoFile(url);
    const image = !video && isImageFile(url);

    // De‑dupe
    tx = Array.from(new Set(tx));

    if (video) {
      // Strip image-only flags
      tx = tx.filter((t) => !t.startsWith('fl_progressive'));
      // Required adaptive transforms
      const required = ['f_auto', 'q_auto', 'vc_auto'];
      required.forEach((r) => {
        if (!tx.includes(r)) tx.push(r);
      });
      // Optional streaming profile (uncomment if you want HLS/DASH packaging automatically):
      // if (!tx.includes('sp_auto')) tx.push('sp_auto');
    } else if (image) {
      if (!tx.some((t) => t.startsWith('q_auto'))) tx.unshift('q_auto');
      if (!tx.find((t) => t.startsWith('fl_progressive:steep')))
        tx.push('fl_progressive:steep');
    } else {
      // Unknown type: leave transforms as-is but still return sanitized
    }

    const finalTx = tx.join(',');
    return `${left}${UP}${finalTx}/${tailParts.join('/')}`;
  }, []);

  // Poster derivation (simple heuristic: swap extension to jpg; Cloudinary auto converts)
  const derivePoster = useCallback((url) => {
    if (!url) return '';
    if (!isVideoFile(url)) return '';
    // Add frame capture (Cloudinary video -> image frame: add so_1, if not present)
    if (url.includes('/upload/')) {
      const [left, right] = url.split('/upload/');
      const parts = right.split('/');
      const txSeg = parts[0];
      // if no frame selection, append so_1 (seek 1s)
      const segs = txSeg.split(',').filter(Boolean);
      if (!segs.find((s) => s.startsWith('so_'))) segs.push('so_1');
      parts[0] = Array.from(new Set(segs)).join(',');
      // Change extension to .jpg for poster element (non-destructive)
      const last = parts[parts.length - 1];
      if (/\.(mp4|m4v|webm|ogg|ogv|mov|flv|3gp|3g2|avi|mkv)$/i.test(last)) {
        parts[parts.length - 1] = last.replace(/\.[a-z0-9]+$/i, '.jpg');
      }
      return `${left}/upload/${parts.join('/')}`;
    }
    return '';
  }, []);

  const handleReact = async (type) => {
    await axiosConn.put(
      `/posts/${post._id}/react`,
      {
        playerId: currentPlayer.data.player.playerId,
        type,
        profilePhoto: currentPlayer.data.player.profilePhoto,
      },
      {
        headers: { Authorization: `Bearer ${currentPlayer.token}` },
      },
    );
    // Fetch updated post and update state
    const res = await axiosConn.get(`/posts/${post._id}`, {
      headers: { Authorization: `Bearer ${currentPlayer.token}` },
    });
    // console.log('Post after reaction:', res.data.data.data);
    setPost(res.data.data.data);
    socket2.emit('updatePost', { updatedPost: res.data.data.data });
  };

  useClickOutside(menu, () => setIsShownMenuItem(false));
  const { darkTheme } = useTheme();
  const classes = useStyles({ darkTheme });

  const handleClick = (event) => {
    // console.log(event.currentTarget);
    setAnchorEl(event.currentTarget);
    setIsShownMenuItem(true);
  };

  const open = Boolean(anchorEl);

  const handleClose = async () => {
    setAnchorEl(null);
    // console.log(post?.desc);
    // console.log(currentPlayer);
    // Emit the deletePost event to the server
    socket2.emit('deletePost', { post: initialPost });

    try {
      //const res =
      await axiosConn.delete(`/posts/${post._id}`, {
        headers: {
          Authorization: `Bearer ${currentPlayer.token}`,
        },
        data: {
          playerId: currentPlayer.data.player.playerId,
        },
      });
      onDelete(initialPost._id);
      //console.log(res.data);
    } catch (err) {
      console.log(err);
    }
    // window.location.reload();
  };

  // Single normalization effect
  useEffect(() => {
    if (!activeUrl) return;
    const vid = isVideoFile(activeUrl);
    setIsVideo(vid);
    const norm = buildNormalizedUrl(activeUrl);
    setNormalizedUrl(norm);
    setPosterUrl(vid ? derivePoster(norm) : '');
    setMediaLoading(true);
    setMediaError(false);
  }, [activeUrl, buildNormalizedUrl, derivePoster]);

  // Intersection Observer for autoplay only when visible
  useEffect(() => {
    if (!isVideo) return;
    const el = mediaContainerRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          setIsInView(e.isIntersecting);
        });
      },
      { threshold: 0.35 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [isVideo]);

  useEffect(() => {
    if (!isImageZoomOpen) return;
    const handleKey = (event) => {
      if (event.key === 'Escape') {
        setIsImageZoomOpen(false);
      }
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isImageZoomOpen]);

  // Page visibility + inView -> control playback
  useEffect(() => {
    if (!isVideo || !videoRef.current) return;
    const v = videoRef.current;
    const shouldPlay = isInView && !document.hidden;
    if (shouldPlay) {
      v.play().catch(() => {});
    } else {
      v.pause();
    }
    const onVis = () => {
      if (isInView && !document.hidden) v.play().catch(() => {});
    };
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, [isVideo, isInView]);

  // Hover to unmute (optional)
  const onVideoEnter = useCallback(() => {
    if (!videoRef.current) return;
    // Only unmute if user interacted (first hover)
    if (!playRequestedRef.current) {
      playRequestedRef.current = true;
      videoRef.current.muted = false;
    }
  }, []);

  const retryMedia = () => {
    setMediaError(false);
    setMediaLoading(true);
    if (videoRef.current) {
      videoRef.current.load();
      videoRef.current.play().catch(() => {});
    }
  };

  const hasMultipleMedia = mediaList.length > 1;
  const thumbsPerPage = 5;
  const thumbSize = 72;
  const thumbGap = 8;
  const thumbArrowGutter = 32;
  const thumbViewportWidth =
    thumbSize * thumbsPerPage + thumbGap * (thumbsPerPage - 1);
  const shouldCarouselThumbs = mediaList.length > thumbsPerPage;
  const goPrevMedia = useCallback(() => {
    if (!hasMultipleMedia) return;
    setMediaIndex((idx) => (idx - 1 + mediaList.length) % mediaList.length);
  }, [hasMultipleMedia, mediaList.length]);
  const goNextMedia = useCallback(() => {
    if (!hasMultipleMedia) return;
    setMediaIndex((idx) => (idx + 1) % mediaList.length);
  }, [hasMultipleMedia, mediaList.length]);

  const updateThumbNav = useCallback(() => {
    const el = thumbsRef.current;
    if (!el) return;
    const maxScrollLeft = el.scrollWidth - el.clientWidth;
    const atStart = el.scrollLeft <= 1;
    const atEnd = el.scrollLeft >= maxScrollLeft - 1;
    setThumbNav((prev) => {
      const next = { canPrev: !atStart, canNext: !atEnd };
      if (prev.canPrev === next.canPrev && prev.canNext === next.canNext) {
        return prev;
      }
      return next;
    });
  }, []);

  const scrollThumbsBy = useCallback(
    (direction) => {
      const el = thumbsRef.current;
      if (!el) return;
      const delta = direction * (thumbSize + thumbGap) * thumbsPerPage;
      el.scrollBy({ left: delta, behavior: 'smooth' });
    },
    [thumbGap, thumbSize, thumbsPerPage],
  );

  useEffect(() => {
    if (!shouldCarouselThumbs) {
      if (thumbsRef.current) {
        thumbsRef.current.scrollLeft = 0;
      }
      setThumbNav((prev) => {
        if (!prev.canPrev && !prev.canNext) return prev;
        return { canPrev: false, canNext: false };
      });
      return;
    }
    updateThumbNav();
  }, [mediaList.length, shouldCarouselThumbs, updateThumbNav]);

  useEffect(() => {
    if (!activeUrl) return;

    const originalUrl = activeUrl;
    const video = isVideoFile(originalUrl);
    setIsVideo(video);

    // Flags
    const hasQAuto = /\/upload\/[^/]*q_auto/.test(originalUrl);
    const hasProgressive = originalUrl.includes('fl_progressive:steep');

    if (video) {
      // VIDEO: remove any image-only progressive flags, add adaptive video transforms if missing
      let url = originalUrl;

      // Strip fl_progressive:steep anywhere inside the transformation segment
      url = url
        .replace(/fl_progressive:steep,?/g, '')
        .replace(/,+/g, ',') // collapse doubles
        .replace(/,\/upload/, '/upload'); // cleanup edge commas (safety)

      if (!hasQAuto) {
        // Insert f_auto,q_auto,vc_auto (keeps other existing transforms if any)
        url = url.replace('/upload/', '/upload/f_auto,q_auto,vc_auto/');
      } else {
        // Ensure vc_auto present (add if missing inside transform block)
        const marker = '/upload/';
        const idx = url.indexOf(marker);
        if (idx !== -1) {
          const after = url.slice(idx + marker.length);
          const parts = after.split('/');
          const tx = parts[0].split(',');
          if (!tx.includes('vc_auto')) tx.push('vc_auto');
          if (!tx.includes('f_auto')) tx.unshift('f_auto');
          parts[0] = Array.from(new Set(tx)).join(',');
          url = url.slice(0, idx + marker.length) + parts.join('/');
        }
      }

      SetQAutoUrl(url);
      SetIsQAutoUrl(true);
      SetIsProgressiveUrl(false); // progressive intentionally off for video
    } else {
      // IMAGE: ensure q_auto + fl_progressive:steep
      let url = originalUrl;
      if (!hasQAuto && !hasProgressive) {
        url = url.replace('/upload/', '/upload/q_auto,fl_progressive:steep/');
      } else if (hasQAuto && !hasProgressive) {
        // Insert fl_progressive:steep right after q_auto
        url = url.replace(
          /q_auto(?!,fl_progressive:steep)/,
          'q_auto,fl_progressive:steep',
        );
      }
      SetQAutoUrl(url);
      SetIsQAutoUrl(true);
      SetIsProgressiveUrl(true);
    }

    setIsLiked(post?.likes?.includes(currentPlayer.data.player.playerId));
  }, [activeUrl, post?.likes, currentPlayer.data.player.playerId]);

  // console.log(qAutoUrl);
  useEffect(() => {
    let mounted = true;
    if (!post || typeof post !== 'object') {
      return null;
    }
    const fetchPlayer = async () => {
      try {
        // This query string is acceptable..
        const res = await axiosConn.get(`/players?playerId=${post?.playerId}`, {
          headers: {
            Authorization: `Bearer ${currentPlayer.token}`,
          },
        });
        // console.log(res.data.data.data[0]);

        if (!mounted) return;
        setPlayer(res.data.data.data[0]);
        // console.log(player.profilePhoto);
      } catch (error) {
        console.error('Error fetching player:', error);
        // Optionally, you can set an error state here to display an error message to the user
      }
    };
    fetchPlayer();

    return () => {
      mounted = false;
    };
  }, [post?.playerId, currentPlayer.token]);

  useEffect(() => {
    let mounted = true;
    //This grabs logged on player's friends.
    const getMyFriends = async () => {
      try {
        const friendList = await axiosConn.get(
          '/players/friends/' + loggedInPlayer.data.player._id,
          {
            headers: {
              Authorization: `Bearer ${loggedInPlayer.token}`,
            },
          },
        );
        if (!mounted) return;
        SetMyFriends(friendList.data);
        //  console.log(friendList.data);
      } catch (err) {
        console.log(err);
      }
    };
    getMyFriends();
    return () => {
      mounted = false;
    };
  }, [loggedInPlayer.token, loggedInPlayer.data.player._id]);

  useEffect(() => {
    setPost(initialPost);
    setLike(initialPost?.likes?.length || 0);
    setComments(initialPost?.comments || []);
    setCommentCount(initialPost?.comments?.length || 0);
    setCommentCount(2); // Reset to initial number of comments to show
  }, [initialPost]);

  const likeHandler = async () => {
    try {
      const response = await axiosConn.put(
        '/posts/' + post._id + '/like',
        {
          playerId: currentPlayer.data.player.playerId,
          profilePhoto: currentPlayer.data.player.profilePhoto,
        },
        {
          headers: {
            Authorization: `Bearer ${currentPlayer.token}`,
          },
        },
      );

      setLike(isLiked ? like - 1 : like + 1);
      setIsLiked(!isLiked);

      // console.log(response.data.data.post);
      // updatePost(response.data.data.post);

      // Emit the updated post to the server
      socket2.emit('updatePost', { updatedPost: response.data.data.post });
    } catch (err) {
      console.error(err);
    }
  };

  const rePostHandler = async () => {
    //console.log(currentPlayer);
    // console.log('rePostHander Top');
    try {
      const res = await axiosConn.put(
        '/posts/' + post._id + '/repost',
        {
          playerId: currentPlayer.data.player.playerId,
        },
        {
          headers: {
            Authorization: `Bearer ${currentPlayer.token}`,
          },
        },
      );
      // console.log(res.data.data.post);

      socket2.emit('sendPost', { post: res.data.data.post });
    } catch (err) {}
    setShare((prev) => prev + 1);
    // setIsLiked(!isLiked);
  };
  const shareHandler = async () => {
    //console.log(currentPlayer);
    // console.log('shareHander Top');
    try {
      const res = await axiosConn.put(
        '/posts/' + post._id + '/reshare',
        {
          playerId: currentPlayer.data.player.playerId,
        },
        {
          headers: {
            Authorization: `Bearer ${currentPlayer.token}`,
          },
        },
      );
      // console.log(res.data);
      if (!res.data.includes('The post has already been reShared')) {
        setShare((prev) => prev + 1);
      }
    } catch (err) {}
    // setIsLiked(!isLiked);
  };

  const showMore = () => {
    setCommentCount((prev) => prev + 3);
    commentCountRef.current += 3; // Show 3 more comments
  };

  useEffect(() => {
    if (!post || typeof post !== 'object') {
      return null;
    }
    //setting views
    axiosConn
      .put(
        '/posts/' + post._id + '/view',
        {},
        {
          headers: {
            Authorization: `Bearer ${currentPlayer.token}`,
          },
        },
      )
      .catch((err) => {
        console.error(
          'View update failed',
          err?.response?.data || err.message || err,
        );
      });
    //console.log(post);
    setViews((view) => view + 1);
    return () => {};
  }, [currentPlayer.token, post?._id]);

  // console.log(post);
  const handleClickJGKOnPostToggle = (event) => {
    // console.log('handleClickJGKOnPostToggle', jgkOnPost);
    jgkOnPost === false ? setJGKOnPost(true) : setJGKOnPost(false);
  };

  const handleSendJGKToPostAmount = async (e) => {
    // console.log('handleSendJGKToPostAmount');
    if (isSoundPlaying) return; // Prevent function from running if sound is playing

    // console.log(e.target.value);
    if (e.key === 'Enter' || e.type === 'click') {
      //send JGK.
      setIsLoading(true);

      // console.log(myFriends);
      let receiver;
      if (post.galaxyId) {
        receiver = post.playerId;
      } else {
        const postPlayerId = myFriends.filter(
          (f) => post?.playerId === f.playerId,
        );
        if (postPlayerId.length === 0) {
          // Handle the case where post.playerId is not in myFriends
          setIsLoading(false);
          return;
        }
        receiver = postPlayerId[0]._id;
      }
      // console.log(
      //   postPlayerId[0]._id,
      //   loggedInPlayer.data.player._id,
      //   sendJGKToPostAmount,
      // );

      if (sendJGKToPostAmount > loggedInPlayer.data.player.jgkTokens) {
        //setError
        return;
      }

      try {
        // console.log('sender: ', loggedInPlayer.data.player._id);
        // console.log('receiver: ', postPlayerId[0]._id);
        // console.log('receivingPostId: ', post._id);
        // console.log(`text: POGW:${post?.playerId}:${post?.desc}: ${post?._id}`);
        // console.log(receiver);
        const res = await axiosConn.post(
          `/jgkTokenTransactions/sendJGKToPostPOGW/`,
          {
            receiver: receiver,
            receivingPostId: post._id,
            sender: loggedInPlayer.data.player._id,
            amount: sendJGKToPostAmount,
            text: `POGW:${post?.playerId}:${post?.desc}: ${post?._id}`,
          },
          {
            headers: {
              Authorization: `Bearer ${loggedInPlayer.token}`,
            },
          },
        );
        // window.location.href = res2.data.session.url;
        // console.log(res.data.post);
        // playSound
        setIsLoading(false);
        setJGKOnPost(false);
        setIsSoundPlaying(true); // Indicate that sound is about to play
        try {
          await playSound(winningSound);
        } catch (audioErr) {
          // swallow audio errors to avoid breaking flow
          console.warn('JGK audio failed to play', audioErr);
        } finally {
          setIsSoundPlaying(false); // Reset after sound has played
        }

        setPost(res.data.post);

        // Emit the updated post to the server
        socket2.emit('updatePost', { updatedPost: res.data.post });
      } catch (err) {
        setIsLoading(false);

        console.log(err);
      }
    }
  };

  useEffect(() => {
    if (modal) {
      // console.log('modal');
      socket2.on('getPlayers', (players) => {
        setOnlinePlayers(
          loggedInPlayer.data.player.friends.filter((f) =>
            players.some((u) => u.playerId === f),
          ),
        );
      });
    }
    return () => {
      // before the component is destroyed
      // unbind all event handlers used in this component
      socket2.off('getPlayers');
    };
  }, [loggedInPlayer.data.player.friends, modal, socket2]);

  // Live post updates (comments, reactions, views, typing, live viewers)
  useEffect(() => {
    if (!socket2 || !post?._id) return undefined;

    const handleCommentsUpdate = ({ postId, comments: incoming }) => {
      if (postId !== post._id) return;
      const nextComments = incoming || [];
      setComments(nextComments);
      setCommentCount(nextComments.length || 0);
      if (nextComments.length > commentCountRef.current) {
        commentCountRef.current = nextComments.length;
      }
    };

    const handleTyping = ({ postId, playerId }) => {
      if (postId !== post._id) return;
      if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
      setCommentTypingHint(
        playerId ? `${playerId} is typing...` : 'Someone is typing...',
      );
      typingTimeoutRef.current = setTimeout(() => {
        setCommentTypingHint('');
      }, 5000);
    };

    const handleLiveViewers = ({ postId, count }) => {
      if (postId !== post._id) return;
      setLiveViewers(typeof count === 'number' ? Math.max(0, count) : 0);
    };

    const handleReactions = ({ postId, likes: likeArr, reactions }) => {
      if (postId !== post._id) return;
      if (Array.isArray(likeArr)) {
        setLike(likeArr.length);
        setPost((prev) => ({ ...prev, likes: likeArr }));
      }
      if (reactions) {
        setPost((prev) => ({ ...prev, reactions }));
      }
    };

    const handleViews = ({ postId, views: incomingViews }) => {
      if (postId !== post._id) return;
      if (typeof incomingViews === 'number')
        setViews(Math.max(0, incomingViews));
    };

    socket2.on('getPostCommentsUpdates', handleCommentsUpdate);
    socket2.on('post:comment:typing', handleTyping);
    socket2.on('post:liveViewers', handleLiveViewers);
    socket2.on('post:reaction', handleReactions);
    socket2.on('post:view', handleViews);
    const handlePostUpdate = ({ updatedPost }) => {
      if (!updatedPost?._id || updatedPost._id !== post._id) return;
      setPost(updatedPost);
    };
    socket2.on('updatePost', handlePostUpdate);

    return () => {
      socket2.off('getPostCommentsUpdates', handleCommentsUpdate);
      socket2.off('post:comment:typing', handleTyping);
      socket2.off('post:liveViewers', handleLiveViewers);
      socket2.off('post:reaction', handleReactions);
      socket2.off('post:view', handleViews);
      socket2.off('updatePost', handlePostUpdate);
      if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
    };
  }, [post?._id, socket2]);

  const sharePostToMessenger = async (receiverPlayer, senderPlayer) => {
    // console.log(receiverPlayer, senderPlayer);
    if (receiverPlayer?._id && senderPlayer?._id) {
      try {
        const res = await axiosConn
          .get(
            `/conversations/find/${receiverPlayer._id}/${senderPlayer._id}`,
            {
              headers: {
                Authorization: `Bearer ${loggedInPlayer.token}`,
              },
            },
          )
          .then(async (res) => {
            if (res.data === null) {
              // console.log('No conversation yet. creating...');
              try {
                //create new conversation.
                const res = await axiosConn.post(
                  `/conversations/`,
                  {
                    senderId: loggedInPlayer.data.player._id,
                    receiverId: receiverPlayer._id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${loggedInPlayer.token}`,
                    },
                  },
                );

                // console.log(res.data);
                setCurrentChat(res.data);
                // console.log(
                //   'sending...to new conversation..conversationId: ',
                //   res.data._id,
                // );
                let message = {
                  sender: loggedInPlayer.data.player._id,
                  text: `sharedPost by ${post.desc}\nhttps://www.joegalaxy.net/post/${post._id} <-- click to goto sharedPost.`,
                  img: post.img,
                  conversationId: res.data._id,
                  // isRead: false,
                  isRead: onlinePlayers?.includes(receiverPlayer._id)
                    ? true
                    : false,
                };
                // console.log(message);
                //send to socket
                try {
                  socket2.emit('sendMessage', {
                    senderId: loggedInPlayer.data.player._id,
                    senderPlayerId: loggedInPlayer.data.player.playerId,
                    receiverId: receiverPlayer._id,
                    text: `sharedPost by ${post.desc}\nhttps://www.joegalaxy.net/post/${post._id} <-- click to goto sharedPost.`,
                    img: post.img,
                  });
                  // checkPageStatus(text, player.data.player._id);
                } catch (err) {
                  console.log(err);
                }

                // console.log(onlinePlayers.includes(receiverId) ? 'true' : 'false');
                try {
                  setLoading(true);
                  //send to messages table
                  const res = await axiosConn.post(
                    `/messages/${
                      onlinePlayers.includes(receiverPlayer._id)
                        ? 'true'
                        : 'false'
                    }`,
                    message,
                    {
                      headers: {
                        Authorization: `Bearer ${loggedInPlayer.token}`,
                      },
                    },
                  );
                  // console.log(res.data.data.data);
                  // console.log(...messages);
                  setLoading(false);
                } catch (err) {
                  setLoading(false);
                  console.log(err);
                }
              } catch (err) {
                console.log(err);
              }
            } else {
              //existing conversation.
              // console.log(
              //   'sending to existing conversation...conversationId: ',
              //   res.data._id,
              // );
              let message = {
                sender: loggedInPlayer.data.player._id,
                text: `sharedPost by ${post.playerId}: ${post.desc}\nhttps://www.joegalaxy.net/post/${post._id} <-- click to goto sharedPost.`,
                img: post.img,
                conversationId: res.data._id,
                // isRead: false,
                isRead: onlinePlayers?.includes(receiverPlayer._id)
                  ? true
                  : false,
              };
              // console.log(message);
              //send to sockedt
              try {
                socket2.emit('sendMessage', {
                  senderId: loggedInPlayer.data.player._id,
                  senderPlayerId: loggedInPlayer.data.player.playerId,
                  receiverId: receiverPlayer._id,
                  text: `sharedPost by ${post.playerId}: ${post.desc}\nhttps://www.joegalaxy.net/post/${post._id} <-- click to goto sharedPost.`,
                  img: post.img,
                });
                // checkPageStatus(text, player.data.player._id);
              } catch (err) {
                console.log(err);
              }

              // console.log(onlinePlayers.includes(receiverId) ? 'true' : 'false');
              try {
                setLoading(true);
                //send to messages
                const res = await axiosConn.post(
                  `/messages/${
                    onlinePlayers.includes(receiverPlayer._id)
                      ? 'true'
                      : 'false'
                  }`,
                  message,
                  {
                    headers: {
                      Authorization: `Bearer ${loggedInPlayer.token}`,
                    },
                  },
                );
                // console.log(res.data.data.data);
                // console.log(...messages);
                setLoading(false);
              } catch (err) {
                setLoading(false);
                console.log(err);
              }
            }
          });
      } catch (err) {
        console.log(err);
      }
    }
  };

  useEffect(() => {
    setDialogIsSupported(checkHtmlDialogElement());
  }, []);

  const handleSharePost = () => {
    setIsLoading(true);

    // console.log('handleSharePost Top');
    // console.log(myFriendsToSharePost);
    myFriendsToSharePost.forEach((friend) => {
      sharePostToMessenger(friend, loggedInPlayer.data.player);
      // sharePostToMessenger(post, friend);
    });
    shareHandler(); //add playerId to reShares on Post.

    setIsLoading(false);
    setModal(false);
  };

  const handleRepost = () => {
    setIsLoading(true);
    // console.log('handleRepost');
    rePostHandler();
    setModal(false);

    setIsLoading(false);
    // window.location.reload();
  };

  const handleIsShareClicked = () => {
    // console.log('handleIsShareClicked');
    setIsShare((prev) => !prev);
  };

  const handleIsRepostClicked = () => {
    // console.log('handleIsRepost');
    setIsRepost((prev) => !prev);
  };

  // Join/leave post room for live viewers/events
  useEffect(() => {
    if (!socket2 || !post?._id) return undefined;
    const payload = { postId: post._id };
    socket2.emit('post:join', payload);
    return () => {
      socket2.emit('post:leave', payload);
    };
  }, [post?._id, socket2]);

  const sortedComments = useMemo(() => {
    if (!comments || comments.length === 0) return [];
    return [...comments].sort((a, b) => {
      return new Date(b.commentAt) - new Date(a.commentAt);
    });
  }, [comments]);

  // if (!post || typeof post !== 'object') {
  //   return null;
  // }
  // console.log(post);
  return (
    <>
      {isImageZoomOpen && !isVideo && normalizedUrl && (
        <div
          className="postImageZoom"
          role="dialog"
          aria-modal="true"
          onClick={() => setIsImageZoomOpen(false)}
        >
          <div
            className="postImageZoom__inner"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="postImageZoom__close"
              onClick={() => setIsImageZoomOpen(false)}
              aria-label="Close image"
            >
              X
            </button>
            <img src={normalizedUrl} alt="" />
          </div>
        </div>
      )}
      <Tooltip
        title={
          post?.isPogw && post.playerId !== currentPlayer?.data.player.playerId
            ? `Proof Of Great Work, consider rewarding JGK`
            : null
        }
      >
        <div
          className={
            post?.isPogw ? 'postPOGW' : darkTheme ? 'postDarkTheme' : 'post'
          }
          // onClick={handlePostClick}
        >
          <div className="postWrapper">
            <div className="postTop">
              <div className="postTopLeft">
                <Link to={`/profile/${player?.playerId}`}>
                  <img
                    className={
                      !mobileView ? 'postProfileImg' : 'postProfileImgMobile'
                    }
                    src={
                      player.profilePhoto
                        ? player.profilePhoto
                        : 'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                    }
                    alt=""
                    loading="lazy"
                  />
                </Link>
                <span
                  className={
                    !mobileView ? 'postPlayerId' : 'postPlayerIdMobile'
                  }
                >
                  {player.playerId}
                </span>
                <div className={!mobileView ? 'postViews' : 'postViewsMobile'}>
                  <VisibilityIcon sx={{ color: 'grey', fontSize: 15 }} />
                  {views}
                  {liveViewers > 0 && (
                    <span
                      style={{
                        marginLeft: 6,
                        fontSize: 11,
                        color: '#4caf50',
                        fontWeight: 600,
                      }}
                      title="Currently viewing"
                    >
                      • {liveViewers} live
                    </span>
                  )}
                </div>
                <span className={!mobileView ? 'postDate' : 'postDateMobile'}>
                  {preciseFormat(post?.createdAt)}
                </span>
                {post?.isPogw ? (
                  !mobileView ? (
                    <span className="pogwTitleSpan">Proof of Great Work</span>
                  ) : (
                    <span className="pogwTitleSpanMobile">POGW</span>
                  )
                ) : null}
              </div>
              <div
                className={`${
                  mobileView && post?.isPogw
                    ? 'postTopRightPOGW'
                    : 'postTopRight'
                } 
    ${darkTheme ? 'darkTheme blackBg' : ''}`}
              >
                {(player.playerId === currentPlayer.data.player.playerId ||
                  (galaxy &&
                    (galaxy.owners || []).some(
                      (owner) => owner._id === currentPlayer.data.player._id,
                    )) ||
                  (galaxy &&
                    (galaxy.administrators || []).some(
                      (admin) => admin._id === currentPlayer.data.player._id,
                    )) ||
                  (galaxy &&
                    (galaxy.moderators || []).some(
                      (moderator) =>
                        moderator._id === currentPlayer.data.player._id,
                    ))) && (
                  <IconButton
                    aria-label="more"
                    onClick={handleClick}
                    aria-haspopup="true"
                    aria-controls="long-menu"
                    onMouseEnter={() => setIsShown(true)}
                    onMouseLeave={() => setIsShown(false)}
                  >
                    {isShown && !mobileView ? (
                      <div
                        className={`${
                          !mobileView
                            ? 'postDeletePostText'
                            : 'postDeletePostMobile'
                        } ${darkTheme ? 'darkTheme blackBg' : ''}`}
                      >
                        Delete Post
                      </div>
                    ) : (
                      !isShownMenuItem && (
                        <MoreVert
                          fontSize={
                            !mobileView || width === 800 ? 'large' : 'small'
                          }
                          style={{
                            color: darkTheme ? 'white' : 'inherit',
                          }}
                        />
                      )
                    )}
                  </IconButton>
                )}
                {isShownMenuItem &&
                  player.playerId === currentPlayer.data.player.playerId && (
                    <Menu
                      anchorEl={anchorEl}
                      keepMounted
                      open={open}
                      classes={{ paper: classes.menu }}
                    >
                      {MyOptions.map((option, i) => (
                        <MenuItem
                          key={i}
                          onClick={handleClose}
                          ref={menu}
                          className={classes.menuItem}
                        >
                          {option}
                        </MenuItem>
                      ))}
                    </Menu>
                  )}
              </div>
            </div>
            {post?.isPogw && (
              <div>
                <Tooltip
                  title={`This post has ${(
                    Math.round(parseFloat(post?.jgkTokens) * 100) / 100
                  ).toFixed(2)} JGK`}
                >
                  <span
                    id="postJGKAmount"
                    className="postJGKAmount"
                    // className={
                    //   post?.jgkTokens < 9999
                    //     ? 'postNotificationIconBadgeJGK'
                    //     : 'postNotificationIconBadgeJGK10K'
                    // }
                  >
                    {post?.jgkTokens &&
                      (
                        Math.round(parseFloat(post?.jgkTokens) * 100) / 100
                      ).toFixed(2)}
                  </span>
                </Tooltip>
                <span className="postJGKBadge">JGK</span>
              </div>
            )}
            <div className="postTop">
              {post && post.location && post.location.address ? (
                <div
                  className="flex-row"
                  style={{ textAlign: 'center', width: '100%' }}
                >
                  <Link
                    to={`/playerMap?lat=${post.location.coordinates[1]}&lon=${post.location.coordinates[0]}&parent=post`}
                    className="mmenu_header hover3"
                  >
                    <Room
                      htmlColor="green"
                      className="shareIcon flashing-icon"
                    />
                  </Link>
                  {post.location.address}
                </div>
              ) : null}
            </div>
            <div className="postCenter" ref={imgRef}>
              {/* {post?.rePosts?.length > 0 && (
                <span className="postText"> */}
              {/* rePosted */}
              {/* {post?.rePosts?.filter(
                    (p) => p.playerId !== currentPlayer.data.player.playerId,
                  )} */}
              {/* </span> */}
              {/* )} */}
              <DynamicHtml
                from="post"
                text={post?.desc}
                setMessageTextIsVideo={setMessageTextIsVideo}
              />
              <div
                ref={mediaContainerRef}
                className="postMediaWrapper"
                style={{
                  position: 'relative',
                  width: isPortrait ? 'min(100%, 420px)' : '100%',
                  margin: isPortrait ? '0 auto' : undefined,
                  aspectRatio:
                    mediaDims.w && mediaDims.h
                      ? `${mediaDims.w} / ${mediaDims.h}`
                      : isVideo
                      ? '16 / 9'
                      : 'auto',
                  // Fallback for browsers without aspect-ratio: fixed height approximation
                  height:
                    !('aspectRatio' in document.documentElement.style) &&
                    mediaDims.w &&
                    mediaDims.h
                      ? `${Math.round((mediaDims.h / mediaDims.w) * 100)}vw`
                      : undefined,
                  maxHeight: isPortrait ? '80vh' : '75vh',
                  overflow: 'hidden',
                  borderRadius: 8,
                  backgroundColor: '#000',
                  backgroundImage: mediaLoading
                    ? 'linear-gradient(110deg,#222 8%,#333 18%,#222 33%)'
                    : 'none',
                  backgroundSize: mediaLoading ? '200% 100%' : undefined,
                  animation: mediaLoading
                    ? 'shimmer 1.2s linear infinite'
                    : 'none',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                tabIndex={hasMultipleMedia ? 0 : -1}
                onKeyDown={(e) => {
                  if (!hasMultipleMedia) return;
                  if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    goPrevMedia();
                  } else if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    goNextMedia();
                  }
                }}
              >
                {isVideo ? (
                  <>
                    <video
                      ref={videoRef}
                      src={normalizedUrl}
                      poster={posterUrl || undefined}
                      muted
                      loop
                      playsInline
                      preload="metadata"
                      controls
                      onLoadedMetadata={() => {
                        try {
                          if (videoRef.current) {
                            const vw = videoRef.current.videoWidth;
                            const vh = videoRef.current.videoHeight;
                            if (vw && vh) setMediaDims({ w: vw, h: vh });
                          }
                        } catch {}
                      }}
                      onLoadedData={() => setMediaLoading(false)}
                      onError={() => {
                        setMediaError(true);
                        setMediaLoading(false);
                      }}
                      onMouseEnter={onVideoEnter}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: isPortrait ? 'contain' : 'cover',
                        display: mediaError ? 'none' : 'block',
                        backgroundColor: '#000',
                      }}
                    />
                    {mediaError && (
                      <div
                        style={{
                          position: 'absolute',
                          inset: 0,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          background: 'rgba(0,0,0,0.6)',
                          color: '#fff',
                          fontSize: 12,
                          gap: 8,
                          textAlign: 'center',
                          padding: 12,
                        }}
                      >
                        <span>Video failed to load.</span>
                        <button
                          onClick={retryMedia}
                          style={{
                            background: '#14b866',
                            color: '#fff',
                            border: 'none',
                            padding: '4px 10px',
                            borderRadius: 4,
                            cursor: 'pointer',
                            fontSize: 12,
                          }}
                        >
                          Retry
                        </button>
                        <a
                          href={normalizedUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: '#9fdfff',
                            textDecoration: 'underline',
                          }}
                        >
                          Open Direct
                        </a>
                      </div>
                    )}
                    {mediaLoading && !mediaError && (
                      <div
                        style={{
                          position: 'absolute',
                          inset: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#ccc',
                          fontSize: 12,
                          letterSpacing: 1,
                        }}
                      >
                        Loading…
                      </div>
                    )}
                  </>
                ) : activeUrl ? (
                  <button
                    type="button"
                    className="postImageButton"
                    onClick={() => {
                      if (mediaLoading || mediaError) return;
                      setIsImageZoomOpen(true);
                    }}
                    aria-label="View image"
                  >
                    <img
                      src={normalizedUrl}
                      alt=""
                      loading="lazy"
                      onLoad={(e) => {
                        try {
                          const el = e.currentTarget;
                          if (el.naturalWidth && el.naturalHeight) {
                            setMediaDims({
                              w: el.naturalWidth,
                              h: el.naturalHeight,
                            });
                          }
                        } catch {}
                        setMediaLoading(false);
                      }}
                      onError={() => {
                        setMediaError(true);
                        setMediaLoading(false);
                      }}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit:
                          mediaDims.h > mediaDims.w ? 'contain' : 'cover',
                        display: mediaError ? 'none' : 'block',
                        backgroundColor: '#000',
                      }}
                    />
                  </button>
                ) : null}

                {mediaError && !isVideo && (
                  <div
                    style={{
                      position: 'absolute',
                      inset: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: 'rgba(0,0,0,0.55)',
                      color: '#fff',
                      fontSize: 12,
                      flexDirection: 'column',
                      gap: 6,
                      padding: 10,
                    }}
                  >
                    <span>Media not available.</span>
                    <a
                      href={activeUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#9fdfff' }}
                    >
                      Open original
                    </a>
                  </div>
                )}
                {hasMultipleMedia && (
                  <>
                    <button
                      type="button"
                      aria-label="Previous media"
                      onClick={goPrevMedia}
                      style={{
                        position: 'absolute',
                        left: 8,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'rgba(0,0,0,0.45)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: 32,
                        height: 32,
                        cursor: 'pointer',
                        fontSize: 18,
                        zIndex: 3,
                      }}
                    >
                      ‹
                    </button>
                    <button
                      type="button"
                      aria-label="Next media"
                      onClick={goNextMedia}
                      style={{
                        position: 'absolute',
                        right: 8,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'rgba(0,0,0,0.45)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: 32,
                        height: 32,
                        cursor: 'pointer',
                        fontSize: 18,
                        zIndex: 3,
                      }}
                    >
                      ›
                    </button>
                    <div
                      style={{
                        position: 'absolute',
                        right: 12,
                        bottom: 12,
                        background: 'rgba(0,0,0,0.5)',
                        color: '#fff',
                        padding: '4px 8px',
                        borderRadius: 12,
                        fontSize: 12,
                        zIndex: 3,
                      }}
                    >
                      {mediaIndex + 1} / {mediaList.length}
                    </div>
                    <div
                      style={{
                        position: 'absolute',
                        bottom: 8,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        display: 'flex',
                        gap: 6,
                        padding: '4px 6px',
                        background: 'rgba(0,0,0,0.35)',
                        borderRadius: 14,
                        zIndex: 3,
                      }}
                    >
                      {mediaList.map((m, idx) => (
                        <button
                          key={m.url || idx}
                          type="button"
                          onClick={() => setMediaIndex(idx)}
                          aria-label={`Go to media ${idx + 1}`}
                          style={{
                            width: 10,
                            height: 10,
                            borderRadius: '50%',
                            border: 'none',
                            background:
                              idx === mediaIndex
                                ? '#fff'
                                : 'rgba(255,255,255,0.5)',
                            cursor: 'pointer',
                            padding: 0,
                          }}
                        />
                      ))}
                    </div>
                    <div
                      style={{
                        position: 'absolute',
                        bottom: 8,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        display: 'flex',
                        gap: 6,
                        padding: '4px 6px',
                        background: 'rgba(0,0,0,0.35)',
                        borderRadius: 14,
                        zIndex: 3,
                      }}
                    >
                      {mediaList.map((m, idx) => (
                        <button
                          key={m.url || idx}
                          type="button"
                          onClick={() => setMediaIndex(idx)}
                          aria-label={`Go to media ${idx + 1}`}
                          style={{
                            width: 10,
                            height: 10,
                            borderRadius: '50%',
                            border: 'none',
                            background:
                              idx === mediaIndex
                                ? '#fff'
                                : 'rgba(255,255,255,0.5)',
                            cursor: 'pointer',
                            padding: 0,
                          }}
                        />
                      ))}
                    </div>
                  </>
                )}
              </div>
              {hasMultipleMedia && (
                <div
                  style={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: '100%',
                    overflow: 'hidden',
                    marginTop: 8,
                    minWidth: 0,
                  }}
                >
                  {shouldCarouselThumbs && (
                    <button
                      type="button"
                      aria-label="Scroll thumbnails left"
                      onClick={() => scrollThumbsBy(-1)}
                      disabled={!thumbNav.canPrev}
                      style={{
                        position: 'absolute',
                        left: 4,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'rgba(0,0,0,0.55)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: 28,
                        height: 28,
                        cursor: 'pointer',
                        zIndex: 2,
                        opacity: thumbNav.canPrev ? 1 : 0.4,
                      }}
                    >
                      {'<'}
                    </button>
                  )}
                  <div
                    ref={thumbsRef}
                    onScroll={shouldCarouselThumbs ? updateThumbNav : undefined}
                    className="postMediaThumbs"
                    style={{
                      display: 'flex',
                      gap: thumbGap,
                      overflowX: 'auto',
                      paddingBottom: 4,
                      width: '100%',
                      maxWidth: shouldCarouselThumbs
                        ? `${thumbViewportWidth + thumbArrowGutter * 2}px`
                        : '100%',
                      boxSizing: 'border-box',
                      scrollSnapType: shouldCarouselThumbs
                        ? 'x mandatory'
                        : 'none',
                      scrollBehavior: shouldCarouselThumbs ? 'smooth' : 'auto',
                      paddingLeft: shouldCarouselThumbs ? thumbArrowGutter : 0,
                      paddingRight: shouldCarouselThumbs ? thumbArrowGutter : 0,
                      margin: shouldCarouselThumbs ? '0 auto' : undefined,
                      minWidth: 0,
                    }}
                  >
                    {mediaList.map((m, idx) => (
                      <button
                        key={m.url || idx}
                        type="button"
                        onClick={() => setMediaIndex(idx)}
                        style={{
                          border:
                            idx === mediaIndex
                              ? '2px solid #14b866'
                              : '1px solid #444',
                          padding: 0,
                          borderRadius: 6,
                          background: '#111',
                          cursor: 'pointer',
                          width: thumbSize,
                          height: thumbSize,
                          flex: '0 0 auto',
                          overflow: 'hidden',
                          scrollSnapAlign: shouldCarouselThumbs
                            ? 'start'
                            : 'none',
                      }}
                      aria-label={`Select media ${idx + 1}`}
                    >
                      {m.type === 'video' ? (
                        <div
                          style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fff',
                            background: '#000',
                            fontSize: 12,
                          }}
                        >
                          ▶
                        </div>
                      ) : (
                        <img
                          src={m.url}
                          alt="thumb"
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          }}
                          loading="lazy"
                        />
                      )}
                    </button>
                  ))}
                  </div>
                  {shouldCarouselThumbs && (
                    <button
                      type="button"
                      aria-label="Scroll thumbnails right"
                      onClick={() => scrollThumbsBy(1)}
                      disabled={!thumbNav.canNext}
                      style={{
                        position: 'absolute',
                        right: 4,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'rgba(0,0,0,0.55)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: 28,
                        height: 28,
                        cursor: 'pointer',
                        zIndex: 2,
                        opacity: thumbNav.canNext ? 1 : 0.4,
                      }}
                    >
                      {'>'}
                    </button>
                  )}
                </div>
              )}
            </div>
            <div className="sendJGKToPostPOGWWrapper">
              {post?.isPogw && (
                <span className="pogwTitleSpanMobile">POGW</span>
              )}
              <div className={jgkOnPost ? 'pogwIconIconClicked' : 'pogwIcon'}>
                <Tooltip
                  title={
                    jgkOnPost
                      ? 'click to close JGK.'
                      : `click to give JGK to ${post?.playerId} for this post.`
                  }
                >
                  <CurrencyExchangeOutlinedIcon
                    onClick={
                      post?.playerId !== loggedInPlayer.data.player.playerId
                        ? handleClickJGKOnPostToggle
                        : null
                    }
                    fontSize={!mobileView ? 'medium' : 'small'}
                  />
                </Tooltip>
              </div>
              {!jgkOnPost && (
                <>
                  <span
                    className={
                      !mobileView
                        ? darkTheme
                          ? 'postJgkdCounter dark-theme blackBg'
                          : 'postJgkdCounter'
                        : 'postJgkdCounterMobile'
                    }
                  >
                    JGK: {jgkTokens || 0}
                  </span>
                  <div className="postLikeProfileImgs">
                    {jgkd > 0 &&
                      post?.jgkdProfileImgs &&
                      post?.jgkdProfileImgs
                        .slice(0, numOfImages)
                        .map((jgkdProfileImg, i) => (
                          <Link
                            to={`/profile/${jgkdProfileImg.playerId}`}
                            key={i}
                          >
                            <img
                              src={
                                jgkdProfileImg.profilePhoto
                                  ? jgkdProfileImg.profilePhoto
                                  : 'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                              }
                              alt=""
                              loading="lazy"
                              style={{
                                transform: `translateX(${-i * 8}px)`,
                                zIndex: `${i}`,
                              }}
                            />
                          </Link>
                        ))}
                  </div>
                </>
              )}
              {jgkOnPost && (
                <>
                  <div className="postJGKInputSend">
                    <div className="sendJGKToPostAmountInputs">
                      <label
                        className="sendJGKToPostAmountLabel"
                        for="sendJGKToPlayerAmount"
                      >
                        Amount:
                      </label>
                      <input
                        type="number"
                        value={sendJGKToPostAmount}
                        id="sendJGKToPlayerAmount"
                        onChange={(e) => setSendJGKToPostAmount(e.target.value)}
                        onKeyUp={handleSendJGKToPostAmount}
                      ></input>
                    </div>
                    <div className="sendJGKToPostPOGWButton">
                      <button
                        className={
                          !jgkOnPost || sendJGKToPostAmount < 1
                            ? 'sendJGKPostSubmitButtonDisabled'
                            : 'sendJGKPostSubmitButton'
                        }
                        value="Send"
                        disabled={sendJGKToPostAmount < 1 ? true : false}
                        onClick={handleSendJGKToPostAmount}
                      >
                        {isLoading ? (
                          <CircularProgress color="inherit" size="20px" />
                        ) : (
                          'Send'
                        )}
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div
              className={
                post?.isPogw
                  ? post?.jgkd.includes(loggedInPlayer.data.player.playerId) ||
                    post?.playerId === loggedInPlayer.data.player.playerId
                    ? 'postBottom'
                    : 'postBottom myDiv'
                  : 'postBottom'
              }
            >
              <Like
                imgRef={imgRef}
                text="+2 JGK, Yay!"
                likes={like}
                likesProfileImgs={post?.likesProfileImgs}
                isLiked={isLiked}
                likeHandler={likeHandler}
                mobileView={mobileView}
                PF={PF}
                title={isLiked ? 'You liked this' : ''}
                width={width}
                textOffset={post?.isPogw ? -13 : -20}
              />
            </div>
            <div style={{ margin: '6px 0' }}>
              <ReactionBar
                post={post}
                currentPlayer={currentPlayer.data.player}
                onReact={handleReact}
              />
            </div>

            {dialogIsSupported && (
              <div className="sharePostModal" title="Share Post">
                <div className="shareCountDiv">
                  <div className="sendOutlinedIcon">
                    <SendOutlinedIcon
                      onClick={() => {
                        setModal(true);
                      }}
                    />
                  </div>
                  <span className="postRePostCounter">
                    {share > 0 ? share : null}
                  </span>
                  <span
                    className={
                      !mobileView ? 'postLikeCounter' : 'postLikeCounterMobile'
                    }
                  >
                    {width > 280 &&
                      (share === 1
                        ? ' share'
                        : share > 1
                        ? ' shares '
                        : 'be 1st to share ')}
                  </span>
                </div>

                <Modal openModal={modal}>
                  <div
                    className={
                      darkTheme
                        ? 'modalContent darkTheme blackBg'
                        : 'modalContent'
                    }
                  >
                    <div className="modalHeaders">
                      {!isRepost && (
                        <div className="shareDiv">
                          <Form>
                            {['checkbox'].map((type) => (
                              <div key={`default-${type}`} className="mb-3">
                                <Form.Check
                                  ref={checkbox}
                                  type={type}
                                  id={`${player._id}`}
                                  // label={` Share`}
                                  onClick={(e) => {
                                    handleIsShareClicked();
                                  }}
                                />
                              </div>
                            ))}
                          </Form>
                          <h2 className="modalHeader">Share</h2>
                        </div>
                      )}

                      {!isShare &&
                        loggedInPlayer.data.player.playerId !==
                          post?.playerId && (
                          <div className="repostDiv">
                            <Form>
                              {['checkbox'].map((type) => (
                                <div key={`default-${type}`} className="mb-3">
                                  <Form.Check
                                    ref={checkbox}
                                    type={type}
                                    id={`${player._id}`}
                                    // label={` Share`}
                                    onClick={(e) => handleIsRepostClicked()}
                                  />
                                </div>
                              ))}
                            </Form>
                            <h2 className="modalHeader">Repost</h2>
                          </div>
                        )}
                    </div>
                    {!isRepost && (
                      <>
                        <div>To: </div>
                        <div
                          className={
                            darkTheme
                              ? 'postRequestPlayersSearchResults darkTheme blackBg'
                              : 'postRequestPlayersSearchResults'
                          }
                        >
                          {
                            <MyFriendsToSharePost
                              searchedPlayers={myFriends}
                              myFriendsToSharePost={myFriendsToSharePost}
                              SetMyFriendsToSharePost={SetMyFriendsToSharePost}
                            />
                          }
                        </div>
                      </>
                    )}

                    <div className="postShareCloseSend topright">
                      <button
                        className="sharePostSubmitButton"
                        onClick={() => {
                          setModal(false);
                        }}
                      >
                        x
                      </button>
                    </div>

                    <div className="postShareCloseSend">
                      <button
                        className={
                          (myFriendsToSharePost &&
                            myFriendsToSharePost.length > 0) ||
                          isRepost
                            ? 'sharePostSubmitButton'
                            : 'sharePostSubmitButtonDisabled'
                        }
                        onClick={isShare ? handleSharePost : handleRepost}
                        disabled={
                          (myFriendsToSharePost &&
                            myFriendsToSharePost.length > 0) ||
                          isRepost
                            ? false
                            : true
                        }
                      >
                        {loading ? (
                          <CircularProgress color="inherit" size="20px" />
                        ) : isShare ? (
                          'Send'
                        ) : (
                          'Go'
                        )}
                      </button>
                    </div>
                  </div>
                </Modal>
              </div>
            )}
            <div
              className={
                post?.isPogw
                  ? post?.jgkd.includes(loggedInPlayer.data.player.playerId) ||
                    post?.playerId === loggedInPlayer.data.player.playerId
                    ? 'commentBottom'
                    : 'commentBottom myDiv'
                  : 'commentBottom'
              }
            >
              <div className="comments_wrap">
                <CreateComment
                  postId={post?._id}
                  setComments={setComments}
                  setCommentCount={setCommentCount}
                  parent="Post"
                  socket2={socket2}
                />
                {commentTypingHint && (
                  <div
                    style={{
                      fontSize: 12,
                      color: '#6c63ff',
                      margin: '4px 2px 6px',
                      fontWeight: 600,
                    }}
                  >
                    {commentTypingHint}
                  </div>
                )}

                <span className="postCommentText">
                  {sortedComments
                    .slice(0, commentCountRef.current)
                    .map((comment) => (
                      <Comment
                        comment={comment}
                        key={comment._id}
                        postId={post?._id}
                        imgRef={imgRef}
                      />
                    ))}
                  {commentCountRef.current <
                    (comments ? comments?.length : 0) && (
                    <div
                      className={`${
                        !mobileView ? 'viewComments' : 'viewCommentsMobile'
                      } ${darkTheme ? 'app dark-theme' : ''}`}
                      onClick={() => showMore()}
                    >
                      View {comments?.length - commentCountRef.current} more{' '}
                      {comments?.length - commentCountRef.current === 1
                        ? 'comment'
                        : 'comments'}
                    </div>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </Tooltip>
    </>
  );
}
